import axios from 'axios';
import { GlobalStore } from '@/store';
import { DialogStore } from '@/store/modules/dialog';
import messageConfig from '@/helpers/message.config';

// import dummy_report from './dummy/report_eval.json';
// import dummy_study from './dummy/usermap.json';
// import dummy_search_con from './dummy/search_con.json';
// import dummyStudy from './dummy/study_inform.json';
// import dummyNotice from './dummy/notices.json';
// const timeout = () => new Promise((resolve) => setTimeout(resolve, 500));

let isRefreshing = false;
let failedQueue = [];
const isLog = false;
// const isLog = true;

const service = axios.create({
    withCredentials: true,
    timeout: 1000 * 30,
    baseURL: process.env.VUE_APP_API_URL,
});

const processQueue = (error, token = null) => {
    failedQueue.forEach((prom) => {
        if (error) prom.reject(error);
        else prom.resolve(token);
    });
    failedQueue = [];
};

service.interceptors.request.use(
    (config) => {
        const gStore = GlobalStore();
        const evalToken = gStore.token_eval;
        config.headers.Authorization = `Bearer ` + evalToken;
        // config.headers['Access-Control-Allow-Origin'] = '*';
        return config;
    },
    (error) => {
        if (isLog) console.error('--Service_EVAL-request ERR:', error.request);
        return Promise.reject(error);
    },
);
/**
 * Response interceptor
 */
service.interceptors.response.use(
    (response) => {
        if (isLog) console.log('-Service_EVAL-response:', response);
        return response;
    },
    (error) => {
        if (isLog) console.log('----------Service_EVAL-error start error.response:', error.response);
        const gStore = GlobalStore();
        const dStore = DialogStore();
        const statusCode = error?.response?.data?.statusCode
        const statusMsg = error?.response?.data?.message

        switch (statusCode) {
            case '848': // 진단평가 답변정보가 중복되었습니다 
                return error?.response;
            case '857': // 학원코드 비유효(진단평가)
            case '847': // 이미진단평가완료
                dStore.openMsg(messageConfig[statusCode] || statusMsg);
                return error?.response;
            case '809': // 유효하지 않은 토큰
            case '801': // 유효하지 않은 요청
            case '867': // 중복로그인  
                gStore.initToken();
                dStore.openMsg(messageConfig[statusCode] || statusMsg, (val) => { window.location.href = gStore.is_member_eval ? '/login' : '/eval-login'; });
                return error?.response;
            case '841': //  진단평가정보x
            case '900': //  내부오류
                if (gStore.is_member_eval) dStore.openMsg(messageConfig[statusCode] || statusMsg, (val) => { window.location.href = '/learninghome' });
                else {
                    gStore.initToken();
                    dStore.openMsg(messageConfig[statusCode] || statusMsg, (val) => { window.location.href = '/eval-login' });
                }
                return error?.response;
            default:
                const originalRequest = error.config;
                if (error?.response?.status === 401 && !originalRequest._retry) {
                    const rtoken = gStore.retoken_eval;
                    if (isRefreshing) {
                        return new Promise(function refFunc(resolve, reject) { failedQueue.push({ resolve, reject }); })
                            .then((token) => {
                                originalRequest.headers.Authorization = `Bearer ` + token;
                                return axios(originalRequest);
                            })
                            .catch((err) => { return Promise.reject(err); });
                    }
                    originalRequest._retry = true;
                    isRefreshing = true;
                    // const refreshToken = localStorage.getItem('refreshToken');
                    return axios
                        .post(process.env.VUE_APP_API_URL + `/api/diagnostic/refresh`, { token: rtoken }, { headers: { Authorization: `Bearer ` + rtoken } })
                        .then((res) => {
                            if (res?.data?.message && res?.data?.message.indexOf('성공') > -1) {
                                const returnData = res.data.data;
                                if (isLog) console.log('@@@@Service_EVAL res:', res);
                                gStore.setTokenForEval(returnData?.accessToken);
                                gStore.setReTokenForEval(returnData?.refreshToken);
                                service.defaults.headers.common.Authorization = `Bearer ` + returnData?.accessToken;
                                processQueue(null, returnData?.accessToken);
                                // 반환
                                return service(originalRequest);
                            }
                            processQueue(error, null);
                            gStore.initToken();
                            window.location.href = gStore.is_member_eval ? '/login' : '/eval-login'
                        })
                        .catch((error) => {
                            if (isLog) console.error('@@@@Service_EVAL catch:', error);
                            processQueue(error, null);
                            gStore.initToken();
                            if (error.response.data.statusCode === '810') dStore.openMsg(`장시간 활동이 없어 자동으로<br/>  로그아웃 되었습니다.`, (val) => { window.location.href = '/login'; });
                            else window.location.href = '/login';
                        })
                        .finally(() => {
                            isRefreshing = false;
                        });
                } else {
                    if (statusCode) {
                        // 그 외 401아닌 모든 statusCode :  
                        if (isLog) console.error('@@@@Service_APP : statusCode', statusCode);
                        gStore.initToken();
                        dStore.openMsg(messageConfig[statusCode] || statusMsg, (val) => { window.location.href = gStore.is_member_eval ? '/login' : '/eval-login'; });
                        return error?.response;
                    } else {
                        if (isLog) console.log('@@@@Service_APP 서버 장애:', error?.response);
                        gStore.initToken();
                        dStore.errorConnection((val) => {});
                    }
                };
        }
    },
);
export default service;
